import Jobs from "../Settings/Scheduler/Jobs";

export default function ExternalScanJobs() {
  return (
    <div className="bg-transparent p-3 pb-20 min-h-screen text-gray-900 dark:text-gray-200">
      <div className="w-full mx-auto">
        {/* Jobs List Table */}
        <Jobs />
      </div>
    </div>
  );
}
